
/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 06/03/2025
 * @update 06/03/2025
 * @file src/components/W17/W17F0091
 */

import {
    Button,
    Card, CardBody,
    Col,
    Image,
    Row,
    Typography, PagingInfo as Paging
} from 'diginet-core-ui/components';
import Icons from "diginet-core-ui/icons";
import { makeStyles } from "diginet-core-ui/theme";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../actions/user-actions";
import * as W17F0091Actions from "../../actions/w17/w17F0091/w17F0091-actions";
import Config from "../../config";
import { Loading } from "../common/loading/loading";
import INVHotModal from "./INVHotModal";

const useStyles = makeStyles((theme) => ({
    cardINV: {
        border: `1px solid ${theme?.colors?.line?.category}`
    },
    discount: {
        position: 'absolute',
        top: 8,
        right: 8,
        color: theme?.colors?.white,
        background: theme?.colors?.danger,
        borderRadius: 4
    },
}));

const numPage = 14;

const W17F0091 = (props) => {
    const classes = useStyles();
    const [formLoading, setFormLoading] = useState(false);
    const [openINVHowModal, setOpenINVHowModal] = useState(false);
    const [dataGrid, setDataGrid] = useState({
        total: 0, rows: []
    });

    const dataINVHotInfo = useRef({});
    const filter = useRef({
        skip: 0, limit: numPage
    });
    const dataGridOringinal = useRef([]);
    const isCustomer = Config.getLocalStorage('LOGIN_MODE') === 'customer';

    useEffect(() => {
        if (!isCustomer) return;
        loadForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCustomer]);

    const handleSetGridData = (data = dataGridOringinal.current, isFirst = false) => {
        if (isFirst) dataGridOringinal.current = data;
        const { skip, limit } = filter.current;
        const dataFilter = (data || []).slice(skip, limit + skip);
        setDataGrid({ total: data.length, rows: dataFilter });
    };

    const loadForm = async () => {
        const params = {
            DataTypeID: 'LoadINVHot',
            StrSearch: '',
            EmployeeID: '',
            QuotationID: '',
            InventoryID: '',
        };
        setFormLoading(true);
        props.W17F0091Actions.loadForm(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                handleSetGridData(data, true);
            }
        });
    };

    const onChangePage = (page) => {
        filter.current = { ...filter.current, skip: page * filter.current.limit };
        handleSetGridData();
    };

    const onChangePerPage = (page) => {
        filter.current = { skip: 0, limit: page };
        handleSetGridData();
    };

    const handleOpenINVHotModal = (status = false, isReloadForm = false) => {
        setOpenINVHowModal(status);
        if (isReloadForm) loadForm(); // Load lại Form
    };

    const renderDataINVHot = useMemo(() => {
        const dataList = dataGrid?.rows.map((item, idx) => {
            const { ImageINVHot = '', InventoryNameHot = '', UnitIDHot = '', IsDiscount } = item || {};
            return (
                <Col xs={6} sm={4} md={2.4} lg={1.71} key={idx}>
                    <Card className={`${classes.cardINV}`} height={380} width={'100%'}>
                        <CardBody className={'height100'}>
                            <div className={'display_row flex-col align-between height100'}>
                                <div>
                                    {IsDiscount === 1 && <div className={'text-right'}><span className={`${classes.discount} pdh1x`}>{Config.lang('Dang_khuyen_mai')}</span></div>}
                                    <div className={'full_w text-center mgt5x'} style={{ maxHeight: 230, overflow: 'hidden' }}><Image width={'100%'} height={'auto'} src={ImageINVHot} /></div>
                                </div>
                                <div>
                                    <Typography type={'h3'} className={'pdv1x'} format={['uppercase']} lineClamp={1} hoverTooltip>{InventoryNameHot}</Typography>
                                    <Typography type={'p3'} color={'secondary'}>{UnitIDHot}</Typography>
                                    <Button
                                        viewType={'outlined'}
                                        color={'primary'}
                                        className={'mgv2x'}
                                        label={Config.lang('Xem_them')}
                                        onClick={() => {
                                            dataINVHotInfo.current = item;
                                            handleOpenINVHotModal(true);
                                        }}
                                    />
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            )
        });
        return dataList;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGrid]);

    if (!isCustomer) return null;
    return (
        <div className={'page-container'}>
            <Row className={'mgb10x'}>
                {formLoading && <Loading />}
                {openINVHowModal && <INVHotModal
                    open={openINVHowModal}
                    dataInfo={dataINVHotInfo.current}
                    handleOpen={(status, reloadForm) => handleOpenINVHotModal(status, reloadForm)}
                    {...props}
                />}
                <Col xs={12}>
                    <div className={'display_row align-center align-between'}>
                        <div className={'display_row align-center'}><Icons name={"Fire"} color={'dynamic/pumpkin'} height={32} width={32} className={'mgr2x'} /><Typography type={'h1'} format={['uppercase']}>{Config.lang('San_pham_noi_bat')}</Typography></div>
                    </div>
                </Col>
                {!Config.isEmpty(dataGrid?.rows) && renderDataINVHot}
            </Row>
            <Paging
                totalItems={dataGrid.total}
                itemsPerPage={numPage}
                listPerPage={[numPage, numPage * 2, numPage * 3, numPage * 4]}
                className={'paging paging-fixed'}
                onChangePage={(page) => onChangePage(page)}
                onChangePerPage={(page) => onChangePerPage(page)}
            />
        </div>
    );
}

export default connect(null, (dispatch) => ({
    W17F0091Actions: bindActionCreators(W17F0091Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W17F0091);


